'use client';

import { useTranslations } from 'next-intl';
import { Filter } from '@terra/ui-design-system';
import type { SignalStatusFilter } from '../../../store/tab/signalsTabScopedFilterStore';
import { useSignalStatusFilterTranslations } from '../../../hooks/useSignalStatusFilterTranslations';
import { isSignalStatusFilterValue } from './signals-filter-options';

export function SignalsStatusFilter({
  value,
  onChange,
}: {
  value: SignalStatusFilter;
  onChange: (value: SignalStatusFilter) => void;
}) {
  const tSignalsFilters = useTranslations('signals.filters');
  const { statusOptions, resolveStatusBadgeText } =
    useSignalStatusFilterTranslations();

  return (
    <Filter
      id="signal-status"
      density="compact"
      isMultiSelect
      placeholder={tSignalsFilters('statusPlaceholder')}
      items={statusOptions}
      value={value}
      contentWidth="320px"
      onChange={(values) => onChange(values.filter(isSignalStatusFilterValue))}
      resolveBadgeText={({ selectedValues }) =>
        resolveStatusBadgeText({ selectedValues })
      }
    />
  );
}
